const UNAV_HEADER_READY_SELECTOR = ".unav-header__track"
const UNAV_FOOTER_READY_SELECTORS = [".unav-footer__track", '[data-unav-component="footer"]']

export const isUnavConfigured = () => Boolean(process.env.REACT_APP_TMO_UNAV_ENV)

const queryUnavHost = (hostSelector, innerSelector) => {
  const host = document.querySelector(hostSelector)
  if (!host) {
    return null
  }
  if (host.shadowRoot) {
    const inShadow = host.shadowRoot.querySelector(innerSelector)
    if (inShadow) {
      return inShadow
    }
  }
  return host.querySelector(innerSelector)
}

export const isUnavHeaderReady = () => {
  if (queryUnavHost("tmo-digital-header", UNAV_HEADER_READY_SELECTOR)) {
    return true
  }
  return Boolean(document.querySelector(UNAV_HEADER_READY_SELECTOR))
}

export const isUnavFooterReady = () => {
  return UNAV_FOOTER_READY_SELECTORS.some((selector) =>
    Boolean(queryUnavHost("tmo-digital-footer", selector))
  )
}

export const isUnavChromeReady = () => isUnavHeaderReady() && isUnavFooterReady()

const observeUnavHosts = (observer) => {
  const hosts = [
    document.querySelector("tmo-digital-header"),
    document.querySelector("tmo-digital-footer"),
  ]

  hosts.forEach((host) => {
    if (!host) {
      return
    }
    observer.observe(host, { childList: true, subtree: true })
    if (host.shadowRoot) {
      observer.observe(host.shadowRoot, { childList: true, subtree: true })
    }
  })
}

/**
 * Resolves when UNAV header and footer are in the DOM, or when timeoutMs elapses.
 * Uses MutationObserver when available; otherwise polls on an interval.
 */
export const waitForUnavChrome = (timeoutMs, onReady) => {
  if (isUnavChromeReady()) {
    onReady()
    return () => {}
  }

  let settled = false
  const finish = () => {
    if (settled) {
      return
    }
    settled = true
    onReady()
  }

  const timeoutId = window.setTimeout(finish, timeoutMs)
  const cleanups = [() => window.clearTimeout(timeoutId)]

  if (typeof MutationObserver === "undefined") {
    finish()
    return () => {
      cleanups.forEach((cleanup) => cleanup())
    }
  }

  const observer = new MutationObserver(() => {
      observeUnavHosts(observer)
      if (isUnavChromeReady()) {
        observer.disconnect()
        finish()
      }
    })

    observeUnavHosts(observer)
    observer.observe(document.body, { childList: true, subtree: true })
    cleanups.push(() => observer.disconnect())

  return () => {
    cleanups.forEach((cleanup) => cleanup())
  }
}
